var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6975 0.733294C10.7645 0.800258 10.798 0.877267 10.798 0.964321C10.798 1.05137 10.7645 1.12838 10.6975 1.19535L6.01674 5.87615C5.94978 5.94312 5.87277 5.9766 5.78571 5.9766C5.69866 5.9766 5.62165 5.94312 5.55469 5.87615L0.873884 1.19535C0.806919 1.12838 0.773438 1.05137 0.773438 0.964321C0.773438 0.877267 0.806919 0.800258 0.873884 0.733294L1.37612 0.231062C1.44308 0.164097 1.52009 0.130615 1.60714 0.130615C1.6942 0.130615 1.77121 0.164097 1.83817 0.231062L5.78571 4.17861L9.73326 0.231062C9.80022 0.164097 9.87723 0.130615 9.96429 0.130615C10.0513 0.130615 10.1283 0.164097 10.1953 0.231062L10.6975 0.733294Z",
    fill: "#2B4141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.f912f61135b9e8550715c7e6820653f6.svg";
export { ForwardRef as ReactComponent };